import * as Sentry from '@sentry/browser';

export default function setSentryTags() {
  Sentry.setTag('error_source', 'frontend');
};
